import { render } from "./AddYoutubeChannel.vue?vue&type=template&id=2fa65d48&scoped=true"
import script from "./AddYoutubeChannel.vue?vue&type=script&lang=js"
export * from "./AddYoutubeChannel.vue?vue&type=script&lang=js"

import "./AddYoutubeChannel.vue?vue&type=style&index=0&id=2fa65d48&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa65d48"]])

export default __exports__